<template>
    <div class="apprentice-simple-card">
        <p class="description">{{ $t('internship.fill_in_the_details_of_the_new_internship_below') }}</p>
        <div class="row">
            <div class="col-12 col-md-8 col-xl-6">
                <div class="internship-setting">
                    <div
                        class="internship-banner-preview"
                        v-if="banner_preview !== ''">
                        <b-img :src="banner_preview"></b-img>
                    </div>
                    <b-alert
                        variant="warning"
                        show>
                        {{ $t('common.fields_with_an_asterisk_are_mandatory') }}
                    </b-alert>

                    <b-form-group
                        class="internship-name"
                        label-for="internship-name-input"
                        :label="$t('common.name')">
                        <b-form-input
                            id="internship-name-input"
                            v-model="name"
                            :placeholder="$t('common.name')">
                        </b-form-input>
                    </b-form-group>

                    <div class="internship-company-address">
                        <b-form-group
                            class="internship-location"
                            label-for="internship-location-input"
                            :label="$t('common.location')">
                            <b-form-input
                                id="internship-location-input"
                                v-model="location"
                                :placeholder="$t('common.location')">
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            class="internship-organization"
                            label-for="internship-organization-input"
                            :label="$t('common.organization')">
                            <b-input-group>
                                <b-input-group-prepend>
                                    <design-2021-apprentice-multiselect-component
                                        id="id"
                                        v-model="organization"
                                        label="name"
                                        :options="organizations"
                                        :show-labels="false"
                                        :multiple-select="false">
                                    </design-2021-apprentice-multiselect-component>
                                </b-input-group-prepend>

                                <b-button
                                    class="btn-add btn-add-organizations"
                                    v-b-modal="'organization-create-modal'"
                                    variant="primary-icon">
                                </b-button>
                            </b-input-group>
                        </b-form-group>
                    </div>

                    <b-form-group
                        class="group-input-file"
                        :label="$t('internship.image')"
                        label-for="internship-banner-input">
                        <b-form-file
                            class="apprentice-file-upload internship-banner-upload"
                            id="internship-banner-input"
                            v-model="file"
                            accept="image/jpeg,image/png"
                            :placeholder="$t('internship.upload_banner')"
                            @change="showPreview">
                        </b-form-file>
                    </b-form-group>

                    <b-form-group
                        class="internship-description"
                        label-for="internship-description-input"
                        :label="$t('common.description')">
                        <ckeditor
                            v-model="description"
                            :editor="editor"
                            :config="editorConfig">
                        </ckeditor>
                    </b-form-group>

                    <b-button
                        class="btn-save btn-save-school-settings"
                        variant="primary"
                        @click="save()">
                        {{ $t('common.save') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-internship-database-create-component',
    props: ['organizationsIn'],
    data() {
        return {
            organizations: this.organizationsIn,
            name: '',
            description: '',
            location: '',
            file: null,
            banner_preview: '',
            organization: [],
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'internship-description',
                bodyClass: 'internship-description-body',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'imageInsert',
                        'mediaEmbed',
                        'insertTable',
                        '|',
                        'fontColor',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'highlight',
                        'specialCharacters',
                        '|',
                        'horizontalLine',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
                simpleUpload: {
                    uploadUrl: this.routes.baseUrl() + '/image/upload',
                },
            },
        };
    },
    methods: {
        showPreview(evt) {
            const file = evt.target.files[0];
            this.banner_preview = URL.createObjectURL(file);
        },
        save() {
            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('location', this.location);
            formData.append('orgId', this.organization.id);
            if (this.file) {
                formData.append('file', this.file);
            }

            const headers = { 'Content-Type': 'multipart/form-data' };

            axios
                .post(this.routes.internshipDatabaseCreate(), formData, { headers: headers })
                .then((response) => {
                    window.location.href = this.routes.internshipDatabase();
                })
                .catch(function (error) {
                    this.alert.ajaxError(error);
                });
        },
        addOrganization(organization) {
            this.organizations.push(organization);
            this.organization = organization;
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    font-weight: $font-weight-medium;
    font-size: $base-font-size;
    color: $text-muted-color;
    line-height: 1.5;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.internship-setting {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    input,
    select,
    textarea {
        margin-bottom: 0;
    }

    .btn-save-school-settings {
        align-self: flex-end;
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }
}

.internship-company-address ::v-deep {
    display: flex;
    flex-direction: column;

    .input-group-prepend {
        flex: 1;

        .multiselect__tags {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
    }

    .btn-add-organizations {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;
        padding-left: map-get($grid-gutter-spacing, 'fifteen');
        padding-right: map-get($grid-gutter-spacing, 'fifteen');

        &:before {
            margin-right: 0;
        }
    }
}

.internship-banner-upload ::v-deep {
    height: 51px;

    label {
        margin-bottom: 0;
    }

    .form-file-text {
        color: $text-muted-color;
    }
}

.internship-banner-preview {
    margin-bottom: $grid-gutter-width;

    img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 150px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .internship-company-address ::v-deep {
        column-gap: $grid-gutter-width;
        flex-direction: row;
        justify-content: space-between;

        .internship-location,
        .internship-organization {
            flex: 1 0 auto;
            max-width: calc(50% - 15px);
        }
    }
}
</style>
